import { render, staticRenderFns } from "./TotalEnergyBarChart.vue?vue&type=template&id=24cdda42&scoped=true&"
import script from "./TotalEnergyBarChart.vue?vue&type=script&lang=js&"
export * from "./TotalEnergyBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cdda42",
  null
  
)

export default component.exports